<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <ValidationObserver ref="WorkCooperation" v-slot="{ handleSubmit }">
      <div class="row">
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  本人是否對其他公司負有保密義務？
                  <p class="en-text">
                    Do I have a duty of confidentiality to other companies?
                  </p>
                </span>
              </div>
              <div class="field-radio">
                <label>
                  <input type="radio" :value="true" v-model="HasNDA" />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input type="radio" :value="false" v-model="HasNDA" />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <template v-for="(item, index) in confidentiality">
          <div class="col-md-12" :key="'Company' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    所負義務對象（與您約定保密義務的公司）
                    <span class="en-text">Company's name</span>
                  </span>
                </div>
                <div class="field-value">
                  <input
                    type="text"
                    maxlength="200"
                    autocomplete="off"
                    readonly
                    @focus="$common.removeReadonly($event)"
                    v-model="item.Company"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-md-12" :key="'Content' + index">
            <div class="field">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  請說明保密義務內容
                  <span class="en-text">Description</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="6"
                  maxlength="200"
                  show-word-limit
                  v-model="item.Content"
                />
              </div>
            </div>
          </div>

          <div class="col-md-6" :key="'StartDate' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    保密義務期間（起）
                    <span class="en-text"
                      >Time for remaining confidential (Start)</span
                    >
                  </span>
                </div>
                <div class="field-value">
                  <el-date-picker
                    class="w-100"
                    type="month"
                    value-format="yyyy-MM"
                    placeholder="YYYY-MM"
                    v-model="item.StartDate"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'IsPermanent' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }"> 是否永久 </span>
                </div>
                <div class="field-radio">
                  <label>
                    <input
                      type="radio"
                      :value="true"
                      v-model="item.IsPermanent"
                    />
                    <span>是 (Yes)</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      :value="false"
                      v-model="item.IsPermanent"
                    />
                    <span>否 (NO)</span>
                  </label>
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div
            v-if="item.IsPermanent === false"
            class="col-md-6"
            :key="'EndDate' + index"
          >
            <div class="field">
              <ValidationProvider
                :rules="{
                  required: true,
                  notBeforeStartDate: item.StartDate,
                }"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    保密義務期間（迄）
                    <span class="en-text"
                      >Time for remaining confidential (End)</span
                    >
                  </span>
                </div>
                <div class="field-value">
                  <el-date-picker
                    class="w-100"
                    type="month"
                    value-format="yyyy-MM"
                    placeholder="YYYY-MM"
                    v-model="item.EndDate"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div
            v-if="confidentiality.length > 1"
            class="col-md-6"
            :key="'button' + index"
          >
            <button type="button" class="del-btn" @click="del(index)">
              {{ $t("BUTTON.RESUME_DELETE") }}
            </button>
          </div>
        </template>
      </div>

      <div class="edit-btn-wrap">
        <!-- 新增 -->
        <button v-if="HasNDA" type="button" class="btn-sm add-btn" @click="add">
          {{ $t("BUTTON.RESUME_ADD") }}
        </button>
        <!-- 儲存 -->
        <button
          type="button"
          class="put-btn"
          @click="handleSubmit(saveConfidentiality)"
        >
          {{ $t("BUTTON.RESUME_SAVE") }}
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseIDLConfidentiality",

  data() {
    return {
      HasNDA: null,
      confidentiality: [],

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },

  methods: {
    // 儲存 保密義務
    saveConfidentiality() {
      this.$api.idl
        .putNDA(this.source, {
          Details: this.confidentiality,
          UserId:
            this.source === "resume" ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "保密義務儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === "resume") {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getConfidentiality();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 保密義務
    getConfidentiality() {
      const candidate =
        this.source === "resume"
          ? this.$cookies.get("candidateId")
          : this.matchId;
      this.updateLoading(true);
      this.$api.idl.getNDA(this.source, candidate).then((response) => {
        if (response.status === 200) {
          this.HasNDA = response.data.HasNDA;
          this.confidentiality = response.data.Details;
        }
        this.updateLoading(false);
      });
    },

    add() {
      this.confidentiality.push({});
    },

    del(index) {
      this.confidentiality.splice(index, 1);
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  watch: {
    HasNDA: function (newVal) {
      if (newVal) {
        if (this.confidentiality.length === 0) {
          this.add();
        }
      } else {
        this.confidentiality = [];
      }
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getConfidentiality();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}

button {
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 15px;
}

.del-btn {
  background: #ff3232;
  margin-top: 25px;
  color: #fff;
  margin-right: 10px;
}

.edit-btn-wrap {
  margin-top: 20px;
  button {
    background: #18c58b;
    color: #fff;
  }
  .add-btn {
    background: #fff;
    color: #000;
    margin-right: 5px;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
